/*!
 * All material copyright ESRI, All Rights Reserved, unless otherwise specified.
 * See https://github.com/Esri/calcite-design-system/blob/main/LICENSE.md for details.
 * v1.9.2
 */
import { S as Scrim, d as defineCustomElement$1 } from './scrim.js';

const CalciteScrim = Scrim;
const defineCustomElement = defineCustomElement$1;

export { CalciteScrim, defineCustomElement };
